import { Button, Stack } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useStyles } from "./styles";

const Page404 = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <Stack
      gap={3}
      className={classes.root}
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Stack>Page not found</Stack>
      <Button
        className={classes.login_again}
        onClick={() => navigate(-1)}
        sx={{ borderRadius: "34px", px: 2 }}
      >
        Back to home
      </Button>
    </Stack>
  );
};

export default Page404;
